var colors = {
  primary1: '#FFBC00',
  primary2: '#FFCC00',
  primary3: '#60584C',
  secondary1: '#545045',
  secondary2: '#7D6948',
  secondary3: '#848687',
  neutral0: '#000000',
  neutral10: '#1C1B1F',
  neutral20: '#313033',
  neutral30: '#484649',
  neutral40: '#605D62',
  neutral50: '#787579',
  neutral60: '#939094',
  neutral70: '#AEAAAE',
  neutral80: '#C9C5CA',
  neutral90: '#E6E1E5',
  neutral95: '#F4EFF4',
  neutral99: '#FFFBFE',
  neutral100: '#FFFFFF'
};

export { colors };
